
import DropZone from /* webpackChunkName: "DropZone" */ "./DropZone";

export default {
    name: "FileInput",
    data: () => ({
        key: 0
    }),
    components: {
        DropZone,
    },
    props: {
        preview: {
            default: false
        },
        single: {
            default: false
        },
    },
    computed: {
        info() {
            return this.$store.state.info;
        },
        enablePreview() {
            return (
                this.info.active === "PreviewTemplate" ||
                (this.info.customVariables
                    ? this.info.customVariables.enablePreview
                    : false)
            );
        },
        hasFiles() {
            return !!this.$store.state.list.length;
        }
    },
    watch: {
        $route(newRoute, oldRoute) {
            this.key++
        }
    }
};
